module.exports = __webpack_public_path__ + "static/media/Decisions_Step1_Image10.7c1fb289.webp";